import request from '@/utils/request'


// 查询视频-订单列表
export function listOrderVideo(query) {
  return request({
    url: '/video/orderVideo/list',
    method: 'get',
    params: query
  })
}

// 查询视频-订单分页
export function pageOrderVideo(query) {
  return request({
    url: '/video/orderVideo/page',
    method: 'get',
    params: query
  })
}

// 查询视频-订单详细
export function getOrderVideo(data) {
  return request({
    url: '/video/orderVideo/detail',
    method: 'get',
    params: data
  })
}

// 新增视频-订单
export function addOrderVideo(data) {
  return request({
    url: '/video/orderVideo/add',
    method: 'post',
    data: data
  })
}

// 修改视频-订单
export function updateOrderVideo(data) {
  return request({
    url: '/video/orderVideo/edit',
    method: 'post',
    data: data
  })
}

// 删除视频-订单
export function delOrderVideo(data) {
  return request({
    url: '/video/orderVideo/delete',
    method: 'post',
    data: data
  })
}
